import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { ToastContainer } from "react-toastify";
import LayoutStyles from "../../../toolkit/baseStyles";
import LineaPagoPublico from "../../components/lineaPagoPublico";
import { parse as parseQueryParams } from "query-string";
import OBFrame from "../../../OnBoardingUI/components/OBFrame/OBFrame.component";

interface Props {
  location: any;
}
interface State {
  onBoarding: boolean;
}

export default class LineaPagoPublicoPage extends Component<Props, State> {
  state: Readonly<State> = {
    onBoarding: false
  };

  componentDidMount(): void {
    const { onBoarding } = parseQueryParams(this.props.location.search);
    this.setState({
      onBoarding: onBoarding === "true"
    });
  }

  render() {
    if (this.state.onBoarding) {
      return (
        <OBFrame>
          <LineaPagoPublico />
        </OBFrame>
      );
    } else {
      return (
        <LayoutStyles>
          <ToastContainer style={{ fontSize: "0.8rem" }} />
          <main>
            <Helmet title="Línea de pago" />
            <LineaPagoPublico />
          </main>
        </LayoutStyles>
      );
    }
  }
}
